module.exports = __webpack_public_path__ + "img/ring_r_skip_0_1.3edec02d.png";